import { ShiftsRow, View } from 'modules/shift_management/lib/types'

export const MAX_WORKAREAS_PER_PAGE = 10
export const MAX_ITEMS_PER_PAGE = 30

export interface PaginationState {
  hasMore: boolean
  isLoading: boolean
  page: number
}

export type PaginationDispatch = (arg0: PaginationAction) => void

export type PaginationAction =
  | {
      type: 'NEXT_PAGE'
    }
  | {
      type: 'RESET_PAGINATION'
    }
  | {
      type: 'CHECK_LAST_PAGE'
      shiftsRows: ShiftsRow[]
      view: View
    }

function resetPagination(state: PaginationState): PaginationState {
  return { ...state, hasMore: true, page: 1 }
}

export function initialPaginationState(): PaginationState {
  return {
    hasMore: true,
    isLoading: false,
    page: 1,
  }
}

export default function reducer(state: PaginationState, action: PaginationAction): PaginationState {
  switch (action.type) {
    case 'NEXT_PAGE':
      if (state.isLoading || !state.hasMore) return state

      return { ...state, isLoading: true, page: state.page + 1 }

    // Bootstrap should check if there are less than 30 employees to avoid extra calls
    case 'CHECK_LAST_PAGE':
      // There are no more items to be loaded. The -1 is because  we're not
      // moving 1 page forward in the end.
      if (action.shiftsRows.length === 0) {
        return { ...state, page: Math.max(state.page - 1, 1), isLoading: false, hasMore: false }
      }

      // TODO: The maximum of elements by page right now is 30. This is a magic
      // number and has to be managed in a different way. I'm iterating so
      // that it can be sent by the backend (together with hasMorePages)
      const maxItems = action.view.isByAreas ? MAX_WORKAREAS_PER_PAGE : MAX_ITEMS_PER_PAGE
      if (action.shiftsRows.length < maxItems) {
        return { ...state, isLoading: false, hasMore: false }
      }

      return { ...state, isLoading: false }

    case 'RESET_PAGINATION':
      return resetPagination(state)

    default:
      return state
  }
}
